var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedInvoices.length > 0 && !_vm.isTeamMember
    ? _c("div", { staticClass: "bulk-section" }, [
        _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.selectedInvoices.length))]),
          _vm._v(
            "\n        invoice" +
              _vm._s(_vm.selectedInvoices.length > 1 ? "s" : "") +
              " selected.\n    "
          ),
        ]),
        _c(
          "div",
          [
            _c("payment-status-button", {
              attrs: {
                "is-bulk": true,
                "bulk-team-member-invoice-ids": _vm.selectedInvoiceIds,
              },
              on: { invoiceBulkStatusUpdate: _vm.handleBulkChangeStatus },
            }),
            _vm.hasAccountingPackage
              ? _c(
                  "md-button",
                  {
                    staticClass: "md-round md-just-icon md-warning",
                    attrs: { title: "Send to Accounting Package" },
                    on: { click: _vm.handleSendToAccountingPackage },
                  },
                  [_c("md-icon", [_vm._v("send")])],
                  1
                )
              : _vm._e(),
            !_vm.isReadOnlyUser
              ? _c("approve-invoice-button", {
                  attrs: {
                    "is-bulk": true,
                    "bulk-team-member-invoice-ids": _vm.draftInvoiceIds,
                  },
                  on: { invoiceBulkApprove: _vm.handleBulkApprove },
                })
              : _vm._e(),
            !_vm.isReadOnlyUser
              ? _c("send-email-button", {
                  attrs: {
                    "is-bulk": true,
                    "bulk-team-member-invoice-ids": _vm.selectedInvoiceIds,
                  },
                  on: { handleBulkSent: _vm.handleBulkSentEmail },
                })
              : _vm._e(),
            _c("delete-invoice-button", {
              attrs: {
                "is-bulk": true,
                "bulk-team-member-invoice-ids": _vm.selectedInvoiceIds,
              },
              on: { invoiceBulkDelete: _vm.handleBulkDelete },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }